// docs/118 PT10 — whose camera follows a unit's jump (a stair, a chute, a portal stone).
// Pure functions: the scene (game/scenes/Encounter.ts) owns the camera.
import type { Tile } from '../sim/types';

/** What these helpers need of a unit. */
export interface FloorUnit { unitId: number; heroId?: number; owner?: string; tile: Tile; onBoard?: boolean }

/**
 * docs/118 PT10: a unit is the local player's when it is a hero-side unit (a hero, or a ranger's
 * companion, which is planned by the ranger's controller) controlled by `me`. Foes, allies and other
 * players' heroes are never mine; with no identity (`me` empty) nothing is.
 */
export function isMine(u: Pick<FloorUnit, 'heroId' | 'owner'> | undefined, owners: Readonly<Record<number, string>>, me: string): boolean {
  if (!u || u.heroId === undefined || !me) return false;
  return (u.owner ?? owners[u.heroId]) === me;
}

/**
 * docs/118 PT10: whether this player's camera goes with a unit that a stair, a portal stone, a chute
 * or a long teleport has just set down far away: only the owner's camera follows, and only when it
 * was the unit being watched (on screen) or the one selected. Everyone else's view stays put.
 */
export function followsJump(u: Pick<FloorUnit, 'heroId' | 'owner'> | undefined, owners: Readonly<Record<number, string>>, me: string, watching: boolean, selected: boolean): boolean {
  return isMine(u, owners, me) && (watching || selected);
}
